import axios from 'axios';
import {
  AuthService,
  LocalStorageService,
  generateTraceParent,
} from 'br2s-ui-common-utils-02';

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Access-Control-Allow-Methods': '*',
    'Content-Type': 'application/json',
  },
});

// istanbul ignore next
axiosInstance.interceptors.request.use((request) => {
  request.headers['traceparent'] = generateTraceParent();

  const endpoints = ['/inbox/messages', '/inbox/message/'];
  const match = endpoints.find((endpoint) => request.url?.includes(endpoint));

  if (match === undefined) return request;

  if (request.method === 'get') {
    // Explicitly pass empty data to persist Content-Type as application/json
    request.data = {};
  }

  const reqUrl = new URL(`${request.baseURL}${request.url}`);

  if (LocalStorageService.hasAuth()) {
    const { uen } = LocalStorageService.getAuthInfo('uen');

    if (!!uen) reqUrl.searchParams.set('uen', uen);
  }

  request.url = reqUrl.toString();

  return request;
});

// istanbul ignore next
axiosInstance.interceptors.response.use(undefined, async (error) => {
  if (AuthService.isTokenExpired(error)) {
    return new Promise((resolve, reject) =>
      AuthService.handleTokenExpiredEz()
        .then((result) => (result ? resolve : reject)(axios(error.config)))
        .catch((error) => reject(error))
    );
  }

  // handle CRM token not found
  if (
    !LocalStorageService.hasAuth() &&
    AuthService.isTokenNotFound(error) &&
    window.location.href.includes('crm')
  ) {
    return new Promise((resolve, reject) => {
      AuthService.handleTokenExpiredEz() // Calls session API
        .then((result) => (result ? resolve : reject)(axios(error.config)))
        .catch((error) => reject(error));
    });
  }

  return Promise.reject(error);
});
